module.exports = __webpack_public_path__ + "static/img/8397_phase_function_Paper_Points.68ffba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8397_phase_function_Paper_Points.png
// module id = IgML
// module chunks = 0